import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { InputGroup, InputRightElement } from '@chakra-ui/react';

import * as Form from 'components/_core/form';
import SunshineCard from 'components/_core/SunshineCard';

import { InvoicePresetsFormSchema } from '../../invoicePresetsForm.schema';
import locales from './locales';

interface QuoteValidityDaysProps {
  control: Control<InvoicePresetsFormSchema>;
  isEnabled: boolean;
  onCheckChange: () => void;
}

const QuoteValidityDays: FC<QuoteValidityDaysProps> = ({
  control,
  isEnabled,
  onCheckChange,
}) => (
  <SunshineCard.Group>
    <Controller
      control={control}
      name="quoteValidityDaysEnabled"
      render={({ field }) => (
        <SunshineCard
          isChecked={field.value}
          onChange={(e) => {
            field.onChange(e.target.checked);
            onCheckChange();
          }}
          title={locales.label}
          variant="checkbox"
        />
      )}
    />

    {isEnabled ? (
      <SunshineCard>
        <Controller
          control={control}
          name="quoteValidityDays"
          render={({ field, formState: { errors } }) => (
            <Form.Field error={errors.quoteValidityDays?.message}>
              <InputGroup>
                <Form.Input
                  onChange={(e) => {
                    const { value } = e.target;
                    field.onChange(value === '' ? null : Number(value));
                  }}
                  type="number"
                  value={field.value ?? ''}
                />

                <InputRightElement>{locales.days}</InputRightElement>
              </InputGroup>
            </Form.Field>
          )}
        />
      </SunshineCard>
    ) : null}
  </SunshineCard.Group>
);

export default QuoteValidityDays;
